/** Shared date helpers for validity ranges on admin forms. */

/** Conventional "open ended" validTill used throughout the schema. */
export const FAR_FUTURE = "2100-01-01";

/** ISO timestamp → value for an <input type="date"> ("" when absent/invalid). */
export function toDateInput(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
}

/** <input type="date"> value → UTC midnight ISO timestamp for the API. */
export function fromDateInput(value: string, fallback: string): string {
  return `${value || fallback}T00:00:00Z`;
}

/** Today's date as an <input type="date"> value (UTC). */
export const today = () => new Date().toISOString().slice(0, 10);
